import MutateFacilityType from './MutateFacilityType';

export default MutateFacilityType